import constants from 'constants/index'

const typeChipColor = (type, classes) => {
  switch (type) {
    case constants.documents.REAL_INCIDENT_VALUE:
      return classes.onTime
    case constants.documents.TEST_INCIDENT_VALUE:
      return classes.frozen
    default:
      return ''
  }
}

export default typeChipColor
